const LoginFlow = (function LoginFlow() {
    const drawer = document.getElementById("siteLogin");
    const modal = document.getElementById("login-modal");
    const emailForm = document.getElementById("login-email-form");
    const emailInput = document.getElementById("login-email");
    const emailError = document.getElementById("login-email-error");
    const personalForm = document.getElementById("login-personal-form");
    const businessForm = document.getElementById("login-business-form");
    const accountTypeOptions = document.getElementById("login-account-type-options");
    const emailTextNodes = document.querySelectorAll("[data-login-email-text]");
    const panels = Array.from(document.querySelectorAll("[data-login-panel]"));
    const actionButtons = Array.from(document.querySelectorAll("[data-login-action]"));
    const destinationTitleNodes = {
        personal: document.querySelector("[data-login-title='personal']"),
        business: document.querySelector("[data-login-title='business']")
    };
    const destinationCopyNodes = {
        personal: document.querySelector("[data-login-copy='personal']"),
        business: document.querySelector("[data-login-copy='business']")
    };
    const destinationBadgeNodes = {
        personal: document.querySelector("[data-login-provider-badge='personal']"),
        business: document.querySelector("[data-login-provider-badge='business']")
    };
    const destinationSubmitNodes = {
        personal: document.querySelector("[data-login-submit-label='personal']"),
        business: document.querySelector("[data-login-submit-label='business']")
    };
    const feedbackNodes = {
        personal: document.querySelector("[data-login-submit-feedback='personal']"),
        business: document.querySelector("[data-login-submit-feedback='business']")
    };
    const personalUsername = document.getElementById("login-personal-username");
    const businessCompanyId = document.getElementById("login-business-id");
    const personalPassword = document.getElementById("login-personal-password");
    const businessPassword = document.getElementById("login-business-password");
    const fiservSettings = drawer ? {
        businessLogonScriptUrl: drawer.dataset.loginFiservBusinessLogonScriptUrl || "",
        businessScriptUrl: drawer.dataset.loginFiservBusinessScriptUrl || "",
        enabled: drawer.dataset.loginFiservEnabled === "true",
        personalScriptUrl: drawer.dataset.loginFiservPersonalScriptUrl || "",
        personalThemeNumber: Number(drawer.dataset.loginFiservPersonalThemeNumber || 1)
    } : {
        businessLogonScriptUrl: "",
        businessScriptUrl: "",
        enabled: false,
        personalScriptUrl: "",
        personalThemeNumber: 1
    };
    const fiservState = {
        error: null,
        initialized: {
            business: false,
            personal: false
        },
        promise: null,
        ready: false
    };
    const providerOrder = ["fiserv", "finxact"];
    const accountTypeOrder = ["personal", "business"];
    const accountConfig = {
        fiserv_personal: {
            badge: "Fiserv Personal",
            choiceLabel: "Personal Online Banking",
            description: "Sign in to your personal online banking account.",
            panel: "personal",
            submitLabel: "Log In",
            title: "Personal banking sign in"
        },
        fiserv_business: {
            badge: "Fiserv Business",
            choiceLabel: "Business Online Banking",
            description: "Sign in to your business online banking account.",
            panel: "business",
            submitLabel: "Log In",
            title: "Business banking sign in"
        },
        finxact_personal: {
            badge: "Digital Consumer",
            choiceLabel: "Digital Banking",
            description: "Consumer digital banking experience",
            panel: "finxact-personal",
            submitLabel: "Continue to Digital Banking",
            title: "Consumer digital banking"
        },
        finxact_business: {
            badge: "Digital Business",
            choiceLabel: "Digital Business Banking",
            description: "Business digital banking experience",
            panel: "finxact-business",
            submitLabel: "Continue to Business Digital Banking",
            title: "Business digital banking"
        }
    };

    let currentEmail = "";
    let currentLookup = null;
    let currentProvider = "";
    let currentAccountCode = "";

    function setBusy(isBusy) {
        if (modal) {
            modal.setAttribute("aria-busy", String(isBusy));
        }
    }

    function setActivePanel(panelName) {
        panels.forEach((panel) => {
            const isActive = panel.dataset.loginPanel === panelName;
            panel.classList.toggle("--active", isActive);
            panel.setAttribute("aria-hidden", String(!isActive));
        });
    }

    function setEmailText(email) {
        emailTextNodes.forEach((node) => {
            node.textContent = email;
        });
    }

    function setEmailError(message) {
        if (emailError) {
            emailError.textContent = message || "";
        }

        if (emailInput) {
            emailInput.setAttribute("aria-invalid", String(Boolean(message)));
        }
    }

    function clearFeedback() {
        Object.values(feedbackNodes).forEach((node) => {
            if (node) {
                node.textContent = "";
            }
        });
    }

    function setFeedback(panelName, message) {
        const node = feedbackNodes[panelName];

        if (node) {
            node.textContent = message || "";
        }
    }

    function getAccountCode(providerKey, accountType) {
        return `${providerKey}_${accountType}`;
    }

    function getNoAccountsMessage(email) {
        return `We didn't find any accounts for ${email}. Please note that new accounts may take up to 24 hours to appear.`;
    }

    function getAccountDetails(accountCode) {
        return accountConfig[accountCode] || accountConfig.finxact_personal;
    }

    function normalizeAccountTypes(accountTypes) {
        if (!Array.isArray(accountTypes)) {
            return [];
        }

        return accountTypeOrder.filter((accountType) =>
            accountTypes.some((value) => String(value).toLowerCase() === accountType)
        );
    }

    function getProviderLookup(lookup, providerKey) {
        const provider = lookup && lookup.providers && typeof lookup.providers === "object"
            ? lookup.providers[providerKey]
            : null;

        if (!provider || typeof provider !== "object") {
            return {
                found: false,
                accountTypes: [],
                pendingApplication: null
            };
        }

        return {
            found: provider.found === true,
            accountTypes: normalizeAccountTypes(provider.accountTypes),
            pendingApplication: typeof provider.pendingApplication === "boolean" ? provider.pendingApplication : null
        };
    }

    function buildDecisionState(lookup) {
        const accountCodes = [];
        for (const providerKey of providerOrder) {
            const providerLookup = getProviderLookup(lookup, providerKey);
            if (!providerLookup.found) {
                continue;
            }
            for (const accountType of providerLookup.accountTypes) {
                accountCodes.push(getAccountCode(providerKey, accountType));
            }
        }

        if (!accountCodes.length) {
            return {
                kind: "no-match",
                message: "We couldn't find a matching online banking experience for that email. Try another email or contact customer support."
            };
        }

        return {
            kind: "choose-account",
            accountCodes
        };
    }

    function renderAccountChoices(accountCodes) {
        if (!accountTypeOptions) {
            return;
        }

        accountTypeOptions.innerHTML = accountCodes.map((accountCode) => {
            const details = getAccountDetails(accountCode);
            return `
                <button type="button" class="login__profile-card" data-login-account-code="${accountCode}">
                    <strong class="login__profile-title">${details.choiceLabel}</strong>
                </button>
            `;
        }).join("");

        const cta = document.querySelector('[data-login-panel="account-type-choice"] .login__enrollment-cta');
        if (cta) {
            const hasPersonal = accountCodes.some((code) => code.endsWith("_personal"));
            const hasBusiness = accountCodes.some((code) => code.endsWith("_business"));
            cta.style.display = hasPersonal && hasBusiness ? "none" : "";
        }
    }

    function updateDestinationPanel(panelName, accountCode) {
        const details = getAccountDetails(accountCode);

        if (panelName === "personal") {
            if (destinationBadgeNodes.personal) {
                destinationBadgeNodes.personal.textContent = details.badge;
            }
            if (destinationTitleNodes.personal) {
                destinationTitleNodes.personal.textContent = details.title;
            }
            if (destinationCopyNodes.personal) {
                destinationCopyNodes.personal.textContent = details.description;
            }
            if (destinationSubmitNodes.personal) {
                destinationSubmitNodes.personal.textContent = details.submitLabel;
            }
            if (personalUsername && !fiservSettings.enabled) {
                personalUsername.value = currentEmail;
            }
        }

        if (panelName === "business") {
            if (destinationBadgeNodes.business) {
                destinationBadgeNodes.business.textContent = details.badge;
            }
            if (destinationTitleNodes.business) {
                destinationTitleNodes.business.textContent = details.title;
            }
            if (destinationCopyNodes.business) {
                destinationCopyNodes.business.textContent = details.description;
            }
            if (destinationSubmitNodes.business) {
                destinationSubmitNodes.business.textContent = details.submitLabel;
            }
            if (businessCompanyId && !fiservSettings.enabled) {
                businessCompanyId.value = currentEmail.split("@")[0] || "";
            }
        }
    }

    async function activateAccount(accountCode) {
        const details = getAccountDetails(accountCode);
        currentAccountCode = accountCode;
        clearFeedback();

        if (details.panel === "finxact-business") {
            const link = document.querySelector("[data-login-business-redirect]");
            if (link) {
                window.location.assign(link.href);
            }
            return;
        }

        if (details.panel === "finxact-personal") {
            const form = document.querySelector(`[data-login-panel="${details.panel}"] form`);
            if (form) {
                form.submit();
            }
            return;
        }

        const isFiserv = details.panel === "personal" || details.panel === "business";

        if (isFiserv && fiservSettings.enabled && !fiservState.ready) {
            setActivePanel("spinner");
            try {
                await ensureFiservScripts();
            } catch (error) {
                // Falls through to render destination panel; initializeFiservPanel surfaces the error feedback.
            }
        }

        updateDestinationPanel(details.panel, accountCode);
        setActivePanel(details.panel);

        if (isFiserv) {
            syncFiservAccountTypeSelectors(details.panel);

            if (fiservSettings.enabled) {
                initializeFiservPanel(details.panel);
            }
        }
    }

    function syncFiservAccountTypeSelectors(activePanel) {
        const fiservTypes = currentLookup
            ? getProviderLookup(currentLookup, "fiserv").accountTypes
            : [];
        const showSelector = fiservTypes.length > 1;
        const activeLabel = activePanel === "business" ? "Business Online Banking" : "Personal Online Banking";

        document.querySelectorAll("[data-login-account-type-wrapper]").forEach((wrapper) => {
            wrapper.style.display = showSelector ? "" : "none";

            const labelEl = wrapper.querySelector("[data-login-account-type-label]");
            if (labelEl) {
                labelEl.textContent = activeLabel;
            }

            wrapper.querySelectorAll("[data-login-fiserv-account-type]").forEach((option) => {
                const optType = option.dataset.loginFiservAccountType;
                option.style.display = fiservTypes.includes(optType) ? "" : "none";
            });

            const toggle = wrapper.querySelector('[data-login-action="toggle-options"]');
            const options = wrapper.querySelector("[data-login-account-type-options]");
            if (toggle && options) {
                toggle.setAttribute("aria-expanded", "false");
                options.classList.add("--hidden");
            }
        });
    }

    function handleFiservAccountTypeChange(event) {
        const option = event.target.closest("[data-login-fiserv-account-type]");
        if (!option) {
            return;
        }
        activateAccount(getAccountCode("fiserv", option.dataset.loginFiservAccountType));
    }

    function applyDecisionState(state) {
        switch (state.kind) {
            case "choose-account":
                currentProvider = "";
                renderAccountChoices(state.accountCodes);
                setActivePanel("account-type-choice");
                return;
            case "activate-account":
                currentProvider = state.accountCode.split("_")[0];
                activateAccount(state.accountCode);
                return;
            case "no-match":
            case "unresolved":
                currentProvider = "";
                currentAccountCode = "";
                returnToLookupEntry();
                setEmailError(getNoAccountsMessage(currentEmail));
                return;
            default:
                returnToLookupEntry();
                setEmailError(getNoAccountsMessage(currentEmail));
        }
    }

    function returnToLookupEntry() {
        clearFeedback();
        setBusy(false);
        setEmailError("");
        currentProvider = "";
        currentAccountCode = "";

        if (emailInput) {
            emailInput.value = currentEmail;
        }

        setActivePanel("start");
    }

    async function liveLookup(email) {
        const response = await fetch("/api/login/accounts", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: email })
        });

        let payload = null;

        try {
            payload = await response.json();
        } catch (error) {
            if (response.ok) {
                throw new Error("invalid_lookup_response");
            }
        }

        if (!response.ok) {
            throw new Error("account_lookup_failed");
        }

        if (!payload || !payload.providers || typeof payload.providers !== "object") {
            throw new Error("invalid_lookup_response");
        }

        return payload;
    }

    async function beginLookup(email) {
        currentEmail = email.trim().toLowerCase();
        currentLookup = null;
        currentProvider = "";
        currentAccountCode = "";
        setEmailText(currentEmail);
        setEmailError("");
        clearFeedback();
        setBusy(true);
        setActivePanel("spinner");

        try {
            const lookup = await liveLookup(currentEmail);
            currentLookup = lookup;
            applyDecisionState(buildDecisionState(lookup));
        } catch (error) {
            console.error("Login lookup failed.", {
                email: currentEmail,
                error
            });
            returnToLookupEntry();
            setEmailError(getNoAccountsMessage(currentEmail));
        } finally {
            setBusy(false);
        }
    }

    function resetToStart() {
        currentEmail = "";
        currentLookup = null;
        currentProvider = "";
        currentAccountCode = "";
        clearFeedback();
        setBusy(false);
        setEmailError("");

        if (emailInput) {
            emailInput.value = "";
        }

        setEmailText("your email");
        setActivePanel("start");
    }

    function getApplicationPath(scriptUrl) {
        return scriptUrl.indexOf("/js/") === -1 ? "" : scriptUrl.split("/js/")[0];
    }

    function getRoutingTransit(form) {
        return form ? form.dataset.routingTransit || "" : "";
    }

    function getProfileNumber(form) {
        return form ? form.dataset.profileNumber || "" : "";
    }

    function loadExternalScript(url, key) {
        return new Promise((resolve, reject) => {
            if (!url) {
                reject(new Error(`missing_${key}_script_url`));
                return;
            }

            const existing = document.querySelector(`script[data-login-vendor-script='${key}']`);

            if (existing) {
                if (existing.dataset.loaded === "true") {
                    resolve();
                    return;
                }

                existing.addEventListener("load", () => resolve(), { once: true });
                existing.addEventListener("error", () => reject(new Error(`failed_to_load_${key}`)), { once: true });
                return;
            }

            const script = document.createElement("script");
            script.async = true;
            script.dataset.loaded = "false";
            script.dataset.loginVendorScript = key;
            script.src = url;
            script.addEventListener("load", () => {
                script.dataset.loaded = "true";
                resolve();
            }, { once: true });
            script.addEventListener("error", () => reject(new Error(`failed_to_load_${key}`)), { once: true });
            document.head.appendChild(script);
        });
    }

    async function ensureFiservScripts() {
        if (!fiservSettings.enabled) {
            return false;
        }

        if (fiservState.ready) {
            return true;
        }

        if (!fiservState.promise) {
            fiservState.promise = (async function () {
                await loadExternalScript(fiservSettings.businessLogonScriptUrl, "business-logon");
                await loadExternalScript(fiservSettings.businessScriptUrl, "business-login");
                await loadExternalScript(fiservSettings.personalScriptUrl, "personal-login");

                if (!window.PBI || typeof window.PBI.RemoteLoginLoad !== "function") {
                    throw new Error("missing_pbi_global");
                }

                if (!window.EBC || typeof window.EBC.RemoteLogin !== "function") {
                    throw new Error("missing_ebc_global");
                }

                fiservState.ready = true;
                fiservState.error = null;
                return true;
            }()).catch((error) => {
                fiservState.error = error;
                fiservState.ready = false;
                throw error;
            });
        }

        return fiservState.promise;
    }

    function initializePersonalFiserv() {
        if (!fiservSettings.enabled || fiservState.initialized.personal || !personalForm || !personalUsername || !personalPassword) {
            return;
        }

        new window.PBI.RemoteLoginLoad({
            applicationPath: getApplicationPath(fiservSettings.personalScriptUrl),
            errorCallback: function () {
                setFeedback("personal", "We couldn't initialize the secure personal banking handoff. Please refresh and try again.");
            },
            formId: personalForm.id,
            passwordId: personalPassword.id,
            routingTransit: getRoutingTransit(personalForm),
            themeNumber: fiservSettings.personalThemeNumber,
            usernameId: personalUsername.id
        });

        fiservState.initialized.personal = true;
        setFeedback("personal", "");
    }

    function initializeBusinessFiserv() {
        if (!fiservSettings.enabled || fiservState.initialized.business || !businessForm || !businessCompanyId || !businessPassword) {
            return;
        }

        new window.EBC.RemoteLogin({
            applicationPath: getApplicationPath(fiservSettings.businessScriptUrl),
            formId: businessForm.id,
            passwordId: businessPassword.id,
            profileNumber: Number(getProfileNumber(businessForm) || 0),
            routingTransit: getRoutingTransit(businessForm),
            usernameId: businessCompanyId.id
        });

        fiservState.initialized.business = true;
        setFeedback("business", "");
    }

    async function initializeFiservPanel(panelName) {
        if (!fiservSettings.enabled || (panelName !== "personal" && panelName !== "business")) {
            return false;
        }

        setFeedback(panelName, "");

        if (fiservState.initialized[panelName]) {
            return true;
        }

        try {
            await ensureFiservScripts();

            if (panelName === "personal") {
                initializePersonalFiserv();
            }

            if (panelName === "business") {
                initializeBusinessFiserv();
            }

            return true;
        } catch (error) {
            setFeedback(panelName, "We couldn't load the secure banking scripts. Please try again or contact customer support.");
            return false;
        }
    }

    function handleCredentialSubmit(panelName) {
        const details = getAccountDetails(currentAccountCode || (panelName === "personal" ? "fiserv_personal" : "fiserv_business"));
        setFeedback(panelName, `${details.badge} sign-in isn't available in this environment. Please contact customer support.`);
    }

    function handleEmailSubmit(event) {
        event.preventDefault();

        if (!emailInput) {
            return;
        }

        const email = emailInput.value.trim();

        if (!email || !emailInput.checkValidity()) {
            setEmailError("Enter a valid email address to continue.");
            emailInput.focus();
            return;
        }

        beginLookup(email);
    }

    function handleAccountChoice(event) {
        const button = event.target.closest("[data-login-account-code]");

        if (!button) {
            return;
        }

        activateAccount(button.dataset.loginAccountCode);
    }

    function handleActionClick(button) {
        const action = button.dataset.loginAction;

        if (action === "reset-email") {
            resetToStart();
            return;
        }

        if (action === "toggle-options") {
            const nextOptions = button.nextElementSibling;
            const isExpanded = button.getAttribute("aria-expanded") === "true";
            button.setAttribute("aria-expanded", String(!isExpanded));

            if (nextOptions) {
                nextOptions.classList.toggle("--hidden", isExpanded);
            }
        }
    }

    function attachEvents() {
        if (emailForm) {
            emailForm.addEventListener("submit", handleEmailSubmit);
        }

        if (personalForm) {
            personalForm.addEventListener("submit", function (event) {
                if (fiservSettings.enabled && fiservState.initialized.personal) {
                    setFeedback("personal", "");
                    return;
                }

                event.preventDefault();

                if (fiservSettings.enabled) {
                    initializeFiservPanel("personal");
                    setFeedback("personal", "Secure sign-in is still loading. Please try again in a moment.");
                    return;
                }

                handleCredentialSubmit("personal");
            });
        }

        if (businessForm) {
            businessForm.addEventListener("submit", function (event) {
                if (fiservSettings.enabled && fiservState.initialized.business) {
                    setFeedback("business", "");
                    return;
                }

                event.preventDefault();

                if (fiservSettings.enabled) {
                    initializeFiservPanel("business");
                    setFeedback("business", "Secure sign-in is still loading. Please try again in a moment.");
                    return;
                }

                handleCredentialSubmit("business");
            });
        }

        if (accountTypeOptions) {
            accountTypeOptions.addEventListener("click", handleAccountChoice);
        }

        document.querySelectorAll("[data-login-account-type-options]").forEach((options) => {
            options.addEventListener("click", handleFiservAccountTypeChange);
        });

        actionButtons.forEach((button) => {
            button.addEventListener("click", function () {
                handleActionClick(button);
            });
        });

        document.addEventListener("click", function (event) {
            document.querySelectorAll('[data-login-action="toggle-options"][aria-expanded="true"]').forEach((button) => {
                const options = button.nextElementSibling;
                if (button.contains(event.target) || (options && options.contains(event.target))) {
                    return;
                }
                button.setAttribute("aria-expanded", "false");
                if (options) {
                    options.classList.add("--hidden");
                }
            });
        });

        drawer.querySelectorAll("a[href='#']").forEach((link) => {
            link.addEventListener("click", function (event) {
                event.preventDefault();
            });
        });

        document.addEventListener("login:opened", function () {
            if (fiservSettings.enabled) {
                ensureFiservScripts().catch(function () {
                    return;
                });
            }
        });
    }

    function init() {
        if (!drawer) {
            return;
        }

        attachEvents();
    }

    return {
        init
    };
}());

window.addEventListener("load", function () {
    LoginFlow.init();
});
